ACC.autocomplete = {
	bindAll: function()
	{
		bindSearchAutocomplete("search_form", "#global-search", "#search", ACC.autocompleteUrl);
	}
};

ACC.recipe.autocomplete = {
	bindAll: function()
	{
		bindSearchAutocomplete('search_form_recipe', "#recipe-search", "#search-filter", ACC.recipe.autocompleteUrl);
	},
};



ACC.faq.autocomplete = {
	bindAll: function()
	{
		bindSearchAutocomplete('search_form_faq', "#faq-search", "#search-filter_faq", ACC.faq.autocompleteUrl);
	},
};


ACC.ifu.autocomplete = {
	bindAll: function()
	{
		bindSearchAutocomplete('search_form_ifu', "#ifu-search", "#search-filter_ifu", ACC.ifu.autocompleteUrl);
	},
};

ACC.repairs.autocomplete = {
	bindAll: function()
	{
		bindSearchRepairersAutocomplete('search_form_repairs', "#repairs-search", "#search-filter_repairs", ACC.repairs.autocompleteUrl);
	},
};

ACC.reparability.autocomplete = {
	bindAll: function()
	{
		bindSearchReparabilityAutocomplete('search_form_reparability', "#reparability-search", "#search-filter_reparability", ACC.reparability.autocompleteUrl);
	},
};


ACC.store.autocomplete = {
	bindAll: function()
	{
		bindSearchAutocomplete('search_form_store', "#store-search", "#search-filter_store", ACC.store.autocompleteUrl);
	},
};

ACC.accprod.autocomplete = {

	bindAll: function()
	{ 
		bindSearchAutocomplete("search_form_accprod", "#accprod-search", "#search-filter_accessoryProduct", ACC.accprod.autocompleteUrl);
	},
};


bindSearchAutocomplete = function(formname, globalId, id, url)
{
	$(id).autocomplete({
		
		source: function( request, response ) {
			$.getJSON(
					url, 
					{
						term : $(id).val()
					},
					function(data) {
						response(data);
					}
				);
		},
		minLength: 2,
		open: function(event, ui) { $(".ui-menu").css("z-index", 10000); },
		close: function(event, ui) { $(".ui-menu").css("z-index", -1); },
		focus: function( event, ui ) {return false;},
		select: function(event, ui) {
			if(ui.item) {
				$(id).val(ui.item.value.trim());
			}
			document.forms[formname].submit();
		},
		autoFocus: function(){return false;},
        delay: ACC.autocompleteDelay
	});
};
bindSearchRepairersAutocomplete = function(formname, globalId, id, url)
{
	$(id).autocomplete({
		
		source: function( request, response ) {
			var termValue = $(id).val() ;
			if ($("form[name="+formname+"] input[name=country]:checked").val()){
				termValue += ","+$("form[name="+formname+"] input[name=country]:checked").val();
			} else if ($("form[name="+formname+"] input[name=country]:hidden").val()){
				termValue += ","+$("form[name="+formname+"] input[name=country]:hidden").val();
			}
			$.getJSON(
					url, 
					{
						term : termValue
					},
					function(data) {
						response(data);
					}
			);
		},
		minLength: 2,
		create: function() {
	        $(this).data('ui-autocomplete')._renderItem = function ( ul, item ) {
				  return 	$( "<li>" ).attr( "data-value", item.address.town )
					.append(
							$("<a>").text(item.address.town)
					)
					.appendTo( ul );
				}
	    },
		open: function(event, ui) { $(".ui-menu").css("z-index", 10000); },
		close: function(event, ui) { $(".ui-menu").css("z-index", -1); },
		focus: function( event, ui ) {return false;},
		select: function(event, ui) {
			if(ui.item) {
				$(id).val(ui.item.address.town.trim());
			}
			document.forms[formname].submit();
		},
		autoFocus: function(){return false;},
        delay: ACC.autocompleteDelay
		
	});
};

bindSearchReparabilityAutocomplete = function(formname, globalId, id, url) {
	$(id).autocomplete({
		source : function(request, response) {
			$.getJSON(url, {
				term : $(id).val()
			}, function(data) {
				response(data);
			});
		},
		minLength : 2,
		open : function(event, ui) {
			$(".ui-menu").css("z-index", 2);
		},
		close : function(event, ui) {
			$(".ui-menu").css("z-index", -1);
		},
		focus : function(event, ui) {
			return false;
		},
		select : function(event, ui) {
			if (ui.item) {
				$(id).val(ui.item.value.trim().toUpperCase());
				event.preventDefault();
			}
		},
		autoFocus : function() {
			return false;
		},
        delay: ACC.autocompleteDelay
	});
};


renderPOSItem =  function (ul, item) {
	 return 	$( "<li>" ).attr( "data-value", item.address.town )
		.append(
				$("<a>")
					.append( $("<div>").attr( "class","bloc-img" )  )
					.append( $("<h4>").text(item.displayName) )
					.append( $("<p>").text(item.address.formattedAddress) )  )
		.appendTo( ul );

}

$(document).ready(function() {
    if(!GSEB.constants.autocompleteRich) ACC.autocomplete.bindAll();
	ACC.recipe.autocomplete.bindAll();
	ACC.faq.autocomplete.bindAll();
	ACC.ifu.autocomplete.bindAll();
	// #BRA-9371
	//ACC.repairs.autocomplete.bindAll();
	//ACC.store.autocomplete.bindAll();
	ACC.reparability.autocomplete.bindAll();
	ACC.accprod.autocomplete.bindAll();
});   
